import { defineMessages } from 'react-intl';

export default defineMessages({
    addSecondaryNamedInsured: {
        id: 'ml.quoteandbind.common.SecondaryNamedInsuredComponent.Would you like to add a secondary named insured?',
        defaultMessage: 'Would you like to add a secondary named insured?'
    },
    dateOfBirth: {
        id: 'ml.quoteandbind.common.SecondaryNamedInsuredComponent.Date of Birth',
        defaultMessage: 'Date of Birth'
    },
    emailAddress: {
        id: 'ml.quoteandbind.common.SecondaryNamedInsuredComponent.Email Address',
        defaultMessage: 'Email Address'
    },
    preferredPhoneNumber: {
        id: 'ml.quoteandbind.common.SecondaryNamedInsuredComponent.Preferred Phone Number',
        defaultMessage: 'Preferred Phone Number'
    },
    addSecondaryNamedInsuredTooltip: {
        id: 'ml.quoteandbind.common.SecondaryNamedInsuredComponent.tooltip.What is a secondary named insured?',
        defaultMessage: 'What is a secondary named insured?'
    },
    addSecondaryNamedInsuredTooltipText: {
        id: 'ml.quoteandbind.common.SecondaryNamedInsuredComponent.tooltip.secondary named insured tooltip text',
        defaultMessage: 'A secondary named insured is typically the person who is co-titled on a vehicle or co-owner on a property deed. They have the same coverage under the policy as the named insured.'
    },
    chooseSecondaryNamedInsured: {
        id: 'ml.quoteandbind.common.Choose the name of the person who will be the secondary named insured on this quote',
        defaultMessage: 'Choose the name of the person who will be the secondary named insured on this quote'
    },
     secondPersonInControl: {
       id: 'ml.quoteandbind.common.SecondaryNamedInsuredComponent.SecondPersonInControl',
            defaultMessage: 'Would you like to add a second person in control?'
    },
    secondaryNamedInsured: {
         id: 'ml.quoteandbind.common.SecondaryNamedInsuredComponent.SecondaryNamedInsured',
            defaultMessage: 'Would you like to add a secondary named insured?'
    },
     secPersonInControl: {
       id: 'ml.quoteandbind.common.secPersonInControl',
            defaultMessage: 'Second Person in Control'
    },
    secNamedInsured: {
         id: 'ml.quoteandbind.common.secNamedInsured',
            defaultMessage: 'Secondary Named Insured'
    },
    fieldRequired: {
        id: 'ml.quoteandbind.common.Required',
        defaultMessage: 'Please enter the missing information. This field is required.'
    },
});
